<h1 mat-dialog-title>Enter Details</h1>
<div mat-dialog-content>
    <form  [formGroup]="Form">

       <!-- Pincode field -->
    <mat-form-field appearance="outline">
        <mat-label>Name</mat-label>
        <input matInput formControlName="name" required>
    </mat-form-field>

     <!-- Status field -->
        <mat-slide-toggle formControlName="active">Status</mat-slide-toggle>
      

    </form>

   

    
</div>

<div mat-dialog-actions style="display: flex;justify-content: flex-end;">
    <button mat-button mat-dialog-close>Cancel</button>
    <button mat-button cdkFocusInitial (click)="saveBrand()">Save</button>
  </div>